export const SET_HIGHLIGHTED_FEATURES = 'SET_HIGHLIGHTED_FEATURES';
export const HIGHLIGHT_FEATURES = 'HIGHLIGHT_FEATURES';
export const UNHIGHLIGHT_FEATURES = 'UNHIGHLIGHT_FEATURES';